import _ from 'lodash';

export const getOtherUser = conversationData => {
  let otherUser = null;

  if (conversationData.participants.length === 1)
    otherUser = conversationData.participants[0];
  else
    otherUser = conversationData.participants.filter(
      user => user.id !== conversationData.currentUserId
    )[0];

  return otherUser;
};

export const getConversationName = conversationData => {
  if (conversationData.participants.length > 2) return conversationData.name;

  const otherUser = getOtherUser(conversationData);

  if (_.isNil(otherUser)) return conversationData.name;

  const { first_name, surname } = otherUser.profile;

  return `${first_name} ${surname}`;
};

export const getConversationAvatar = conversationData => {
  if (conversationData.participants.length > 2) return {};

  let otherUser = getOtherUser(conversationData);

  if (_.isNil(otherUser)) return {};

  const { avatar, thumbnails } = otherUser.profile;

  return {
    image: avatar,
    thumbnails
  };
};
